export default {
  shared_breadcrumb_back_btn: "Volver",
  shared_flat_list_empty_msg: "Ningún elemento encontrado",
  shared_flat_list_no_title: "Sin título",
  shared_flat_table_empty_msg: "Ningún registro encontrado",
  shared_cliente_company_label: "Empresa:",
  shared_cliente_phone_label: "Teléfono:",
  shared_cliente_cnpj_label: "CNPJ/CIF:",
  shared_cliente_email_label: "Correo electrónico:",
  shared_orcamento_status_label: "Estado:",
  shared_quotation_card_waiting: "Presupuesto en análisis",
  shared_quotation_card_details_btn: "Detalles",
  shared_quotation_column_no_quotes: "Ninguna cotización en esta columna",
  shared_quotation_column_show_less: "Mostrar menos",
  shared_quotation_column_show_more: "Ver más (#vr0# restantes)",
  shared_quotation_section_show_hide: "Mostrar/Ocultar",
  shared_estimate_respond_no_estimate: "Ninguna estimación cargada.",
  shared_estimate_respond_no_item: "Ningún ítem",
  shared_estimate_respond_obs_label: "Observación adicional",
  shared_estimate_respond_obs_placeholder: "Ingrese la respuesta...",
  shared_estimate_respond_total_label: "Valor Total",
  shared_estimate_respond_finish_btn: "Finalizar Respuesta",
  shared_estimate_respond_item_details: "Detalles del Ítem",
  shared_estimate_respond_select_service: "Seleccionar Servicio / Pieza",
  shared_estimate_respond_filter_label: "Filtrar",
  shared_estimate_respond_filter_placeholder: "Escriba para filtrar...",
  shared_estimate_respond_qty_label: "Cantidad",
  shared_estimate_respond_price1_label: "Precio 1",
  shared_estimate_respond_price2_label: "Precio 2",
  shared_estimate_respond_back_btn: "Volver",
  shared_estimate_respond_add_btn: "Añadir",
  shared_estimate_respond_close_btn: "Cerrar",
  shared_resp_no_client_msg: "Ningún cliente cargado.",
  shared_resp_client_company: "Empresa",
  shared_resp_client_name: "Nombre",
  shared_resp_client_phone: "Teléfono",
  shared_resp_client_cnpj: "CNPJ/CIF",
  shared_resp_client_date: "Fecha",
  shared_resp_client_email: "Correo electrónico",
  shared_resp_form_items_added: "Elementos añadidos",
  shared_resp_form_obs_label: "Observación adicional",
  shared_resp_form_placeholder: "Ingrese la respuesta...",
  shared_resp_modal_price: "Precio",
  shared_accept_estimate_accepted_title: "¡Estimación Aceptada!",
  shared_accept_estimate_process_error: "No se pudo procesar la solicitud.",
  shared_accept_estimate_modal_title: "✅ Aceptar Estimación",
  shared_accept_estimate_processing_btn: "Procesando...",
  shared_accept_estimate_confirm_btn: "Confirmar Aceptación",
  shared_accept_estimate_description: "Al confirmar, su estimación será aceptada y avanzará al siguiente estado del flujo.",
  shared_accept_estimate_simple_success_msg: "La aceptación de la estimación fue registrada con éxito.",
  shared_service_msg_equip_updated: "¡Equipo actualizado!",
  shared_service_msg_equip_created: "¡Equipo registrado!",
  shared_service_msg_equip_save_error: "Error al guardar el equipo",
  shared_service_msg_photo_uploaded: "¡Foto enviada!",
  shared_service_msg_photo_upload_error: "Error al enviar la foto",
  shared_service_msg_photo_removed: "¡Foto eliminada!",
  shared_service_msg_photo_remove_error: "Error al eliminar la foto",
  shared_service_msg_laudo_uploaded: "¡Informe enviado!",
  shared_service_msg_laudo_upload_error: "Error al enviar el informe",
  shared_service_msg_laudo_removed: "¡Informe eliminado!",
  shared_service_msg_laudo_remove_error: "Error al eliminar el informe",
  shared_breadcrumb_details: "Detalles",
  shared_breadcrumb_equipments: "Equipos",
  shared_breadcrumb_home: "Inicio",
  shared_breadcrumb_quote_service: "Solicitar Cotizacion",
  shared_breadcrumb_quotations: "Mis Servicios",
  shared_breadcrumb_shipping: "Instrucciones de Envío",
  shared_clients_add_btn: "Agregar",
  shared_clients_address_label: "Dirección",
  shared_clients_address_placeholder: "Ej: Calle de las Flores, 123 - Centro",
  shared_clients_cnpj_invalid: "CNPJ inválido",
  shared_clients_cnpj_label: "CNPJ",
  shared_clients_cnpj_placeholder: "Ej: 12.345.678/0001-90",
  shared_clients_cnpj_required: "CNPJ es obligatorio",
  shared_clients_cpf_invalid: "CPF inválido",
  shared_clients_cpf_label: "CPF",
  shared_clients_cpf_placeholder: "Ej: 123.456.789-00",
  shared_clients_cpf_required: "CPF es obligatorio",
  shared_clients_create_btn: "Crear Cliente",
  shared_clients_delete_btn: "Eliminar",
  shared_clients_delete_confirm_title: "Confirmar Eliminación",
  shared_clients_delete_warning: "Seguro que deseas eliminar {{name}}?",
  shared_clients_edit_btn: "Editar",
  shared_clients_edit_title: "Editar Cliente",
  shared_clients_email_invalid: "Correo inválido",
  shared_clients_email_placeholder: "Ej: contacto@empresa.com",
  shared_clients_filter_doc_placeholder: "Filtrar por CPF/CNPJ...",
  shared_clients_filter_name_placeholder: "Filtrar por nombre...",
  shared_clients_modal_title: "Clientes",
  shared_clients_name_placeholder: "Ej: Empresa LTDA o Juan Pérez",
  shared_clients_name_required: "Nombre / Razón Social es obligatorio",
  shared_clients_new_title: "Nuevo Cliente",
  shared_clients_no_clients_found: "Ningún cliente encontrado",
  shared_clients_obs_placeholder: "Información adicional sobre el cliente",
  shared_clients_pagination_next: "Siguiente",
  shared_clients_pf_label: "Persona Física",
  shared_clients_phone_placeholder: "Ej: (11) 99999-8888",
  shared_clients_pj_label: "Persona Jurídica",
  shared_clients_save_changes_btn: "Guardar Cambios",
  shared_clients_table_actions: "Acciones",
  shared_clients_table_document: "CPF / CNPJ",
  shared_clients_table_name: "Nombre / Razón Social",
  shared_clients_table_type: "Tipo",
  shared_clients_type_required: "Tipo es obligatorio",
  shared_details_add_btn: "Agregar",
  shared_details_attach_invoice_btn: "Adjuntar Factura",
  shared_details_attach_modal_title: "Agregar Factura (PDF o XML)",
  shared_details_attention_label: "Atención",
  shared_details_btn: "Detalles",
  shared_details_cancel_btn: "Cancelar",
  shared_details_close_btn: "Cerrar",
  shared_details_cnpj_label: "CNPJ:",
  shared_details_company_label: "Empresa:",
  shared_details_date_label: "Fecha:",
  shared_details_delete_tooltip: "Eliminar",
  shared_details_download_info_msg: "El archivo #vr0# sera descargado.",
  shared_details_download_tooltip: "Descargar/Visualizar",
  shared_details_email_label: "E-mail:",
  shared_details_enter_name_warning: "Por favor, ingrese un nombre para la factura.",
  shared_details_error_label: "Error",
  shared_details_file_size_label: "Tamaño:",
  shared_details_invoice_name_label: "Nombre de la Factura",
  shared_details_invoice_name_placeholder: "Ej: NF-e 12345",
  shared_details_invoices_title: "🧾 Facturas de Envío",
  shared_details_name_label: "Nombre:",
  shared_details_no_btn: "No",
  shared_details_no_client_msg: "No se encontro ningun cliente.",
  shared_details_no_invoices_msg: "No hay facturas adjuntas.",
  shared_details_phone_label: "Teléfono:",
  shared_details_remove_invoice_confirm_btn: "Sí, eliminar",
  shared_details_remove_invoice_title: "¿Eliminar Factura?",
  shared_details_remove_invoice_warning: "Esta acción no se puede deshacer.",
  shared_details_save_btn: "Guardar",
  shared_details_see_more_btn: "Ver Más",
  shared_details_select_file_msg: "Haga clic para seleccionar el archivo",
  shared_details_select_file_warning: "Por favor, seleccione un archivo para subir.",
  shared_details_success_label: "Éxito",
  shared_details_uploading_btn: "Enviando...",
  shared_details_view_btn: "Visualizar",
  shared_details_warning_label: "Aviso",
  shared_details_yes_btn: "Sí",
  shared_edit_btn: "Editar",
  shared_equip_brand_label: "Marca:",
  shared_equip_ca_label: "CA:",
  shared_equip_card_code_label: "Cód",
  shared_equip_card_details_btn: "Detalles",
  shared_equip_card_item_label: "Ítem",
  shared_equip_card_last_rev_label: "Últ. Revisión",
  shared_equip_card_next_rev_label: "Próx. Revisión",
  shared_equip_card_pending_status: "PENDIENTE",
  shared_equip_download_label: "Descargar",
  shared_equip_form_active_label: "Activo",
  shared_equip_form_add_photo_after_btn: "Agregar Foto Después",
  shared_equip_form_add_photo_before_btn: "Agregar Foto Antes",
  shared_equip_form_attention_label: "Atención",
  shared_equip_form_back_btn: "Volver",
  shared_equip_form_brand_label: "Marca",
  shared_equip_form_ca_label: "CA",
  shared_equip_form_cancel_btn: "Cancelar",
  shared_equip_form_close_btn: "Cerrar",
  shared_equip_form_data_section_title: "📌 Datos del Equipo",
  shared_equip_form_deactivate_warning: "Este equipo será eliminado permanentemente si guarda este cambio.",
  shared_equip_form_delete_photo_error: "No fue posible eliminar la foto",
  shared_equip_form_error_label: "Error",
  shared_equip_form_last_rev_label: "Última Revisión",
  shared_equip_form_laudo_default_desc: "Informe enviado por el sistema",
  shared_equip_form_laudo_default_name: "Informe tecnico",
  shared_equip_form_laudo_name_prompt: "Nombre del informe",
  shared_equip_form_laudos_section_title: "📑 Informes",
  shared_equip_form_loading_msg: "Cargando...",
  shared_equip_form_location_label: "Ubicación",
  shared_equip_form_model_label: "Modelo",
  shared_equip_form_next_rev_label: "Próxima Revisión",
  shared_equip_form_no_btn: "No",
  shared_equip_form_obs_label: "Observación Técnica",
  shared_equip_form_photos_section_title: "📷 Fotos",
  shared_equip_form_remove_laudo_title: "¿Eliminar este informe?",
  shared_equip_form_remove_photo_title: "¿Eliminar esta foto?",
  shared_equip_form_save_btn: "Guardar",
  shared_equip_form_save_changes_btn: "Guardar Cambios",
  shared_equip_form_save_equip_btn: "Guardar Equipo",
  shared_equip_form_save_error: "No fue posible guardar el equipo",
  shared_equip_form_save_first_laudos_msg: "Guarde el equipo primero para añadir informes.",
  shared_equip_form_save_first_photos_msg: "Guarde el equipo primero para añadir fotos.",
  shared_equip_form_save_first_warning: "Atención",
  shared_equip_form_saving_btn: "Guardando...",
  shared_equip_form_search_placeholder: "Escriba para buscar servicio",
  shared_equip_form_select_service_error: "Error",
  shared_equip_form_send_laudo_btn: "Enviar Informe (PDF)",
  shared_equip_form_serial_label: "Serie",
  shared_equip_form_service_label: "Servicio vinculado",
  shared_equip_form_success_label: "Éxito",
  shared_equip_form_understand_btn: "Entendido",
  shared_equip_form_upload_laudo_error: "No fue posible enviar el informe",
  shared_equip_form_upload_photo_error: "No fue posible enviar la foto",
  shared_equip_form_yes_btn: "Sí",
  shared_equip_item_label: "Ítem:",
  shared_equip_last_rev_label: "Últ. Rev.:",
  shared_equip_modal_title: "Registro Rápido de Equipo",
  shared_equip_model_label: "Modelo:",
  shared_equip_next_rev_label: "Próx. Rev.:",
  shared_equip_no_history_msg: "No hay informes registrados.",
  shared_equip_no_photos_msg: "No hay fotos registradas.",
  shared_equip_pending_revision_label: "🔴 Revisión pendiente",
  shared_equip_photo_alt: "Foto del equipo",
  shared_equip_qr_code_label: "Código QR:",
  shared_equip_serial_label: "Serie:",
  shared_image_modal_alt: "Imagen modal alt",
  shared_menu_add_equipment: "Agregar Equipo",
  shared_menu_equipments: "Equipos",
  shared_optional_label: "Opcional",
  shared_quotation_client_label: "Cliente",
  shared_quotation_doc_num: "Núm.Doc:",
  shared_quotation_table_status: "Estado",
}
